import {
  KeyboardArrowDown,
  Edit,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "./../../assets/img/no-record.png";
import {
  getAllCatPaginateAction,
  getAllSubCatPaginateAction,
  getAiCategoriesAction,
  addCategoryAction,
  updateCategoryAction,
  getOneCatDetailsAction,
  updateSubCategoryAction,
  addSubCategoryAction,
  getOneSubCatDetailsAction,
  updateSubCatStatusAction,
  updateCatStatusAction,
} from "../../actions/AiActions";
import ReactPaginate from "react-paginate";
import * as code from "./../../config/Constants";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import * as message from "./../../config/CommonMessages";

class AiCatSubCategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      showSpinner: false,

      allCategories: [],
      allSubCategories: [],
      aiCategoryList: [],

      catPageSize: 5,
      catPage: 0,
      catPageCount: 0,

      subCatPageSize: 5,
      subCatPage: 0,
      subCatPageCount: 0,

      categoryName: "",
      categoryId: "",
      editCategoryId: "",
      editSubCategoryId: "",
      categoryStatus: true,
      subCategoryName: "",
      subCategoryStatus: true,
      categoryFlag: "Add",
      subCategoryFlag: "Add",
      showCategoryModal: false,
      showSubCategoryModal: false,
    };
  }
  catColumns = [
    {
      name: "Category",
      selector: "category",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Status",
      selector: "Status",
      sortable: false,
      width: "115px",
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];

  subCatColumns = [
    {
      name: "Category",
      selector: "category",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Subcategory",
      selector: "subCategory",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Status",
      selector: "Status",
      sortable: false,
      width: "115px",
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];

  componentWillMount() {
    this.getAllCategories();
    this.getAllSubCategories();
  }
  getAllCategories() {
    this.setState({
      showLoader: true,
    });
    this.props
      .getAllCatPaginateAction(this.state.catPageSize, this.state.catPage)
      .then((res) => {
        this.setState({
          allCategories: res.data.data || [],
          catPageCount: res.data.total,
          showLoader: false,
        });
      });
  }

  getAllSubCategories() {
    this.setState({
      showSpinner: true,
    });
    this.props
      .getAllSubCatPaginateAction(
        this.state.subCatPageSize,
        this.state.subCatPage
      )
      .then((res) => {
        this.setState({
          allSubCategories: res.data.data || [],
          subCatPageCount: res.data.total,
          showSpinner: false,
        });
      });
  }

  catChangePage = async (event) => {
    this.setState({ catPage: event.selected }, () => {
      this.getAllCategories();
    });
  };

  subCatChangePage = async (event) => {
    this.setState({ subCatPage: event.selected }, () => {
      this.getAllSubCategories();
    });
  };

  catHandleChange = (event) => {
    this.setState({ catPageSize: event.target.value, catPage: 0 }, () => {
      this.getAllCategories();
    });
  };

  subCatHandleChange = (event) => {
    this.setState({ subCatPageSize: event.target.value, subCatPage: 0 }, () => {
      this.getAllSubCategories();
    });
  };

  catChangeStatus = (id) => {
    let data = {
      id: id,
    };
    this.props
      .updateCatStatusAction(data)
      .then((res) => {
        if (res.status === code.OK) {
          this.getAllCategories();
        } else {
          this.getAllCategories();
        }
      })
      .catch((err) => {});
  };

  subCatChangeStatus = (id) => {
    let data = {
      id: id,
    };
    this.props
      .updateSubCatStatusAction(data)
      .then((res) => {
        if (res.status === code.OK) {
          this.getAllSubCategories();
        } else {
          this.getAllSubCategories();
        }
      })
      .catch((err) => {});
  };

  openCategoryModal = () => {
    this.setState({
      showCategoryModal: !this.state.showCategoryModal,
    });
  };

  submitCategory = () => {
    let data = {
      name: this.state.categoryName,
      isActive: this.state.categoryStatus,
    };

    if (this.state.categoryFlag === "Add") {
      this.props
        .addCategoryAction(data)
        .then((res) => {
          if (res.status === code.OK) {
            this.getAllCategories();
            this.openCategoryModal();
          } else {
            this.getAllCategories();
            this.openCategoryModal();
          }
        })
        .catch((err) => {});
    } else if (this.state.categoryFlag === "Edit") {
      this.props
        .updateCategoryAction(data, this.state.editCategoryId)
        .then((res) => {
          if (res.status === code.OK) {
            this.getAllCategories();
            this.openCategoryModal();
          } else {
            this.getAllCategories();
            this.openCategoryModal();
          }
        })
        .catch((err) => {});
    }
  };

  getCategory = (id) => {
    this.props
      .getOneCatDetailsAction(id)
      .then((res) => {
        if (res.status === code.OK) {
          this.setState({
            categoryName: res.data.name,
            categoryStatus: res.data.isActive,
          });
        }
      })
      .catch((err) => {});
  };

  clearCategoryData = () => {
    this.setState({
      categoryName: "",
      categoryStatus: true,
    });
  };

  openSubCategoryModal = () => {
    this.setState(
      {
        showSubCategoryModal: !this.state.showSubCategoryModal,
      },
      () => {
        if (this.state.showSubCategoryModal) {
          this.props.getAiCategoriesAction().then((res) => {
            this.setState({ aiCategoryList: res.data.data });
          });
        }
      }
    );
  };

  submitSubCategory = () => {
    let data = {
      categoryId: this.state.categoryId,
      name: this.state.subCategoryName,
      isActive: this.state.subCategoryStatus,
    };
    if (this.state.subCategoryFlag === "Add") {
      this.props
        .addSubCategoryAction(data)
        .then((res) => {
          if (res.status === code.OK) {
            this.getAllSubCategories();
            this.openSubCategoryModal();
          } else {
            this.getAllSubCategories();
            this.openSubCategoryModal();
          }
        })
        .catch((err) => {});
    } else if (this.state.subCategoryFlag === "Edit") {
      this.props
        .updateSubCategoryAction(data, this.state.editSubCategoryId)
        .then((res) => {
          if (res.status === code.OK) {
            this.getAllSubCategories();
            this.openSubCategoryModal();
          } else {
            this.getAllSubCategories();
            this.openSubCategoryModal();
          }
        })
        .catch((err) => {});
    }
  };

  getSubCategory = (id) => {
    this.props
      .getOneSubCatDetailsAction(id)
      .then((res) => {
        if (res.status === code.OK) {
          this.setState({
            categoryId: res.data.categoryId,
            subCategoryName: res.data.name,
            subCategoryStatus: res.data.isActive,
          });
        }
      })
      .catch((err) => {});
  };

  clearSubCategoryData = () => {
    this.setState({
      categoryId: "",
      subCategoryName: "",
      subCategoryStatus: true,
    });
  };

  render() {
    let catRows = [];
    let catLen = this.state.allCategories.length;
    for (let i = 0; i < catLen; i++) {
      let cat = this.state.allCategories[i];
      let data = {
        category: cat.name,

        Status: cat.isActive ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() => this.catChangeStatus(cat._id)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() => this.catChangeStatus(cat._id)}
          />
        ),

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.setState({
                  categoryFlag: "Edit",
                  editCategoryId: cat._id,
                });
                this.getCategory(cat._id);
                this.openCategoryModal();
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      catRows.push(data);
    }
    let subCatRows = [];
    let subCatLen = this.state.allSubCategories.length;
    for (let j = 0; j < subCatLen; j++) {
      let subCat = this.state.allSubCategories[j];
      let data = {
        category: subCat.categoryName,

        subCategory: subCat.name,

        Status: subCat.isActive ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() => this.subCatChangeStatus(subCat._id)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() => this.subCatChangeStatus(subCat._id)}
          />
        ),

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.setState({
                  subCategoryFlag: "Edit",
                  editSubCategoryId: subCat._id,
                });
                this.getSubCategory(subCat._id);
                this.openSubCategoryModal();
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      subCatRows.push(data);
    }
    return (
      <div>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center mt-10">
              <Col xs="4">
                <h4 className="title-med mt-0 pt-1">AI Categories</h4>
              </Col>
              <Col align="right" className="contact-btn">
                <FormControl
                  sx={{ m: 0, minWidth: 120 }}
                  size="small"
                  className="mr-3"
                >
                  <InputLabel id="demo-select-small">Limit</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={this.state.catPageSize}
                    label="Page"
                    onChange={this.catHandleChange}
                    style={{ backgroundColor: "hsl(0,0%,100%)" }}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="primary"
                  className="btn-blue btn-head"
                  onClick={() => {
                    this.setState({ categoryFlag: "Add" });
                    this.clearCategoryData();
                    this.openCategoryModal();
                  }}
                >
                  Add Category
                </Button>
              </Col>
            </Row>
            <DataTable
              columns={this.catColumns}
              data={catRows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {catRows.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={this.state.catPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={this.catChangePage}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={this.state.catPage}
                />
              </div>
            )}
          </div>
        )}

        {this.state.showSpinner ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center mt-10">
              <Col xs="4">
                <h4 className="title-med mt-0 pt-1">AI Subcategories</h4>
              </Col>
              <Col align="right" className="contact-btn">
                <FormControl
                  sx={{ m: 0, minWidth: 120 }}
                  size="small"
                  className="mr-3"
                >
                  <InputLabel id="demo-select-small">Limit</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={this.state.subCatPageSize}
                    label="Page"
                    onChange={this.subCatHandleChange}
                    style={{ backgroundColor: "hsl(0,0%,100%)" }}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="primary"
                  className="btn-blue btn-head"
                  onClick={() => {
                    this.setState({ subCategoryFlag: "Add" });
                    this.clearSubCategoryData();
                    this.openSubCategoryModal();
                  }}
                >
                  Add Subcategory
                </Button>
              </Col>
            </Row>
            <DataTable
              columns={this.subCatColumns}
              data={subCatRows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {subCatRows.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={this.state.subCatPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={this.subCatChangePage}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={this.state.subCatPage}
                />
              </div>
            )}
          </div>
        )}
        <Modal
          show={this.state.showCategoryModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400"
          backdrop={false}
        >
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              {this.state.categoryFlag} Category
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                categoryName: Yup.string().required(
                  message.ENTER_CATEGORY_NAME
                ),
              })}
              onSubmit={(values, errors) => {
                this.submitCategory();
              }}
            >
              <Form className="form-sm form-admin" style={{ marginBottom: 15 }}>
                <div className="form-group">
                  <label>
                    Category Name<span className="text-danger"> *</span>
                  </label>
                  <Field
                    type="text"
                    className="form-control"
                    name="categoryName"
                    onChange={(e) => {
                      this.setState({ categoryName: e.target.value });
                    }}
                  />
                  <ErrorMessage
                    name="categoryName"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>

                <div className="form-group">
                  <Field
                    type="checkbox"
                    name="Isactive"
                    checked={this.state.categoryStatus}
                    onChange={(e) => {
                      this.setState({
                        categoryStatus: e.target.checked,
                      });
                    }}
                    style={{ marginRight: 5 }}
                  />
                  <label
                    htmlFor="status"
                    className="form-check-label"
                    style={{ paddingRight: 26 }}
                  >
                    Status
                  </label>
                  <ErrorMessage
                    name="Isactive"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>

                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  type="submit"
                  style={{ marginRight: 10 }}
                >
                  Save
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.openCategoryModal();
                  }}
                >
                  Cancel
                </Button>
              </Form>
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showSubCategoryModal}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400"
          backdrop={false}
        >
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              {this.state.subCategoryFlag} Subcategory
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                categoryId: Yup.string().required(message.SELECT_CATEGORY),
                subCategoryName: Yup.string().required(
                  message.ENTER_SUBCATEGORY_NAME
                ),
              })}
              onSubmit={(values, errors) => {
                this.submitSubCategory();
              }}
            >
              <Form className="form-sm form-admin" style={{ marginBottom: 15 }}>
                <div className="form-group">
                  <label>
                    Category<span className="text-danger"> *</span>
                  </label>

                  <div className="c-select">
                    <select
                      name="categoryId"
                      className="form-control form-control-sm form-control-head"
                      value={this.state.categoryId}
                      onChange={(e) => {
                        this.setState({
                          categoryId: e.target.value,
                        });
                      }}
                    >
                      <option value="">Select Category</option>
                      {this.state.aiCategoryList.map((cat) => {
                        return (
                          <>
                            <option value={cat._id}>{cat.name}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                  <ErrorMessage
                    name="categoryId"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>

                <div className="form-group">
                  <label>
                    Subcategory Name<span className="text-danger"> *</span>
                  </label>
                  <Field
                    type="text"
                    className="form-control"
                    name="subCategoryName"
                    onChange={(e) => {
                      this.setState({ subCategoryName: e.target.value });
                    }}
                  />
                  <ErrorMessage
                    name="subCategoryName"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>

                <div className="form-group">
                  <Field
                    type="checkbox"
                    name="Isactive"
                    checked={this.state.subCategoryStatus}
                    onChange={(e) => {
                      this.setState({
                        subCategoryStatus: e.target.checked,
                      });
                    }}
                    style={{ marginRight: 5 }}
                  />
                  <label
                    htmlFor="status"
                    className="form-check-label"
                    style={{ paddingRight: 26 }}
                  >
                    Status
                  </label>
                  <ErrorMessage
                    name="Isactive"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>

                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  type="submit"
                  style={{ marginRight: 10 }}
                >
                  Save
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.openSubCategoryModal();
                  }}
                >
                  Cancel
                </Button>
              </Form>
            </Formik>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getAllCatPaginateAction,
    getAllSubCatPaginateAction,
    getAiCategoriesAction,
    addCategoryAction,
    updateCategoryAction,
    getOneCatDetailsAction,
    updateSubCategoryAction,
    addSubCategoryAction,
    getOneSubCatDetailsAction,
    updateSubCatStatusAction,
    updateCatStatusAction,
  }
)(AiCatSubCategoryList);
